import React from 'react';
import { TextField } from '@mui/material';
import { colors, shape } from '../../design/tokens';

// Outlined fields and inline quantity fields are intentionally distinct variants.
export default function AppField({ appearance = 'outlined', sx, ...props }) {
    const underline = appearance === 'underline';
    return (
        <TextField
            variant={underline ? 'standard' : 'outlined'}
            {...props}
            sx={{
                ...(underline ? {
                    '& .MuiInput-root': { borderBottom: `2px solid ${colors.brand}` },
                    '& .MuiInput-root:after': { borderBottomColor: colors.brandDark },
                } : {
                    '& .MuiOutlinedInput-root': {
                        minHeight: shape.fieldMinHeight,
                        borderRadius: `${shape.controlRadius}px`,
                        bgcolor: colors.surface,
                    },
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.brandDark,
                        borderWidth: 2,
                    },
                }),
                ...sx,
            }}
        />
    );
}
